import {
  KeyboardAvoidingView,
  StyleSheet,
  Text,
  TextInput,
  TouchableOpacity,
  View,
  Image,
} from "react-native";
import { useState } from "react";
import * as React from "react";

import Ionicons from "@expo/vector-icons/Ionicons";
import { useNavigation } from "@react-navigation/native";

//TRADUCCION
import { translations } from "../../components/translations";
import { I18n } from "i18n-js";
const i18n = new I18n(translations);
//TEMAS
import { useTheme } from "@react-navigation/native";
import { ThemeContext } from "../../components/contexts";

//RESPONSIVE
import "@expo/match-media";
import { useMediaQuery } from "react-responsive";

export let nameFilled = "";
export let lastnameFilled = "";
export let telefFilled = "";

const RegisterScreen2 = (props) => {
  const { colors } = useTheme();

  const { language } = React.useContext(ThemeContext);

  i18n.locale = language;
  i18n.enableFallback = true;

  const [name, setName] = useState("");
  const [lastname, setLastname] = useState("");
  const [pref, setPref] = useState("");
  const [telef, setTelef] = useState("");

  function nameHandler(text) {
    setName(text);
    nameFilled = text;
  }

  function lastnameHandler(text) {
    setLastname(text);
    lastnameFilled = text;
  }

  function prefHandler(text) {
    setPref(text);
    telefFilled = "+" + text + telef;
  }

  function telefHandler(text) {
    setTelef(text);
    telefFilled = "+" + pref + text;
  }

  const navigation = useNavigation();

  const navigateNext = () => {
    navigation.navigate("Register3");
  };

  const navigateBack = () => {
    navigation.goBack();
  };

  let buttonStyle;
  let buttonDisabled = false;
  if (name !== "" && lastname !== "") {
    buttonDisabled = false;
    buttonStyle = [
      styles.nextButton,
      styles.buttonShadow,
      { backgroundColor: colors.main, shadowColor: colors.shadowColor },
    ];
  } else {
    buttonDisabled = true;
    buttonStyle = [
      styles.nextButton,
      { backgroundColor: colors.buttonDisabled },
    ];
  }

  const isTabletOrMobileDevice = useMediaQuery({
    maxDeviceWidth: 1224,
    // alternatively...
    query: "(max-device-width: 1224px)",
  });

  if (isTabletOrMobileDevice) {
    return (
      <View style={styles.container}>
        <View style={{ marginBottom: 0 }}>
          <Image
            style={styles.loginImage}
            source={require("./../../assets/MSLogo.png")}
          />
        </View>

        <View>
          <Text
            style={{
              fontFamily: "Kodchasan-Regular",
              marginTop: 60,
              textAlign: "center",
              fontSize: 18,
              color: colors.textColor,
            }}
          >
            Parece que estás utilizando un móvil o una tablet.
          </Text>
          <Text
            style={{
              fontFamily: "Kodchasan-Bold",
              marginTop: 60,
              textAlign: "center",
              color: colors.textColor,
            }}
          >
            Por favor utiliza la aplicación oficial.
          </Text>
        </View>
        <View
          style={{
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            overflow: "visible",
          }}
        >
          <TouchableOpacity
            style={{ width: "100%", height: 100, margin: 25 }}
            onPress={() => {
              window.open(
                "https://play.google.com/store/apps/details?id=com.msinvs.msinvs", '_blank'
              );
            }}
          >
            <Image
              style={{ resizeMode: "contain", width: "100%", height: 100 }}
              source={{
                uri: "https://msinvs.com/webtest/images/googleplay_img.png",
              }}
            />
          </TouchableOpacity>
          <TouchableOpacity
            style={{ width: "100%", height: 100 }}
            onPress={() => {
              window.open(
                "https://apps.apple.com/es/app/msinvs/id1565847618", '_blank'
              );
            }}
          >
            <Image
              style={{ resizeMode: "contain", width: "100%", height: 100 }}
              source={{
                uri: "https://msinvs.com/webtest/images/appstore_img.png",
              }}
            />
          </TouchableOpacity>
        </View>

        <View
          style={{
            flex: 1,
            alignItems: "flex-end",
            justifyContent: "flex-end",
          }}
        >
          <Text style={[styles.copyrightText, { color: colors.textColor }]}>
            {i18n.t("copyright")}
          </Text>
        </View>
      </View>
    );
  }

  return (
    <View
      style={[
        styles.container,
        {
          backgroundColor: colors.main,
          justifyContent: "center",
          margin: 0,
          padding: 0,
        },
      ]}
    >
      <View
        style={[
          {
            justifyContent: "flex-start",
            alignItems: "center",
            padding: 70,
            paddingBottom: 0,
            backgroundColor: colors.background,
            borderRadius: 25,
            width: 450,
            height: 750,
          },
          styles.buttonShadow,
        ]}
      >
        <View style={styles.backButtonContainer}>
          <TouchableOpacity onPress={navigateBack} style={styles.backButton}>
            <Ionicons
              name="ios-chevron-back"
              size={34}
              color={colors.mainTransparency}
            />
          </TouchableOpacity>
        </View>

        <View style={styles.registerImageContainer}>
          <Image
            style={styles.registerImage}
            source={require("./../../assets/MSLogo.png")}
          />

          <View style={styles.registerHeaderContainer}>
            <Ionicons name="ios-person" size={34} color={colors.main} />
            <Text
              style={[styles.registerHeaderText, { color: colors.textColor }]}
            >
              {i18n.t("datosPersonales")}
            </Text>
          </View>
        </View>
        <KeyboardAvoidingView
          behavior="position"
          style={styles.registerInputContainer}
        >
          <View
            style={[
              styles.registerInputBox,
              {
                backgroundColor: colors.textInputBackground,
                borderColor: colors.main,
              },
            ]}
          >
            <TextInput
              placeholder={i18n.t("nombre")}
              placeholderTextColor={colors.mainTransparency}
              value={name}
              onChangeText={(text) => nameHandler(text)}
              style={[styles.registerInput, { color: colors.main }]}
            />
          </View>
          <View
            style={[
              styles.registerInputBox,
              {
                backgroundColor: colors.textInputBackground,
                borderColor: colors.main,
              },
            ]}
          >
            <TextInput
              placeholder={i18n.t("apellidos")}
              placeholderTextColor={colors.mainTransparency}
              value={lastname}
              onChangeText={(text) => lastnameHandler(text)}
              style={[styles.registerInput, { color: colors.main }]}
            />
          </View>
          <View
            style={[
              styles.registerInputBox,
              {
                backgroundColor: colors.textInputBackground,
                borderColor: colors.main,
              },
            ]}
          >
            <Text
              style={{
                fontFamily: "Kodchasan-Regular",
                color: colors.main,
              }}
            >
              +
            </Text>
            <TextInput
              placeholder="XX"
              maxLength={3}
              placeholderTextColor={colors.mainTransparency}
              value={pref}
              onChangeText={(text) => prefHandler(text)}
              style={[
                styles.registerInput,
                { color: colors.main, width: "25%" },
              ]}
            />
            <TextInput
              placeholder={i18n.t("telefono")}
              placeholderTextColor={colors.mainTransparency}
              value={telef}
              onChangeText={(text) => telefHandler(text)}
              style={[styles.registerInput, { color: colors.main }]}
            />
          </View>
        </KeyboardAvoidingView>
        <View style={styles.nextButtonContainer}>
          <TouchableOpacity
            disabled={buttonDisabled}
            onPress={navigateNext}
            style={buttonStyle}
          >
            <Text
              style={[styles.nextButtonText, { color: colors.buttonTextColor }]}
            >
              {i18n.t("siguiente")}
            </Text>
          </TouchableOpacity>
          <Text style={[styles.copyrightText, { color: colors.textColor }]}>
            {i18n.t("copyright")}
          </Text>
        </View>
      </View>
    </View>
  );
};

export default RegisterScreen2;

const styles = StyleSheet.create({
  container: {
    justifyContent: "flex-start",
    alignItems: "center",
    padding: 70,
    paddingTop: 66,
    paddingBottom: 0,
    minHeight: "100%",
  },

  buttonShadow: {
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.3,
    shadowRadius: 4,
    elevation: 2,
  },

  //IMAGEN LOGO
  registerImageContainer: {
    margin: "auto",
    width: "100%",
    height: "auto",
    paddingVertical: 0,
    marginBottom: 10,
  },

  registerImage: {
    alignSelf: "center",
    width: 115,
    height: 115,
    marginBottom: 10,
  },

  //OPTIONS
  registerHeaderContainer: {
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    marginBottom: 50,
  },
  registerHeaderText: {
    fontSize: 24,
    fontFamily: "Kodchasan-Bold",
    textAlign: "center",
  },
  //INPUTS
  registerInputContainer: {
    width: "100%",
  },
  registerInputBox: {
    paddingHorizontal: 15,
    paddingVertical: 10,
    marginBottom: 25,
    borderRadius: 10,
    borderStyle: "solid",
    borderWidth: 2,
    flexDirection: "row",
    justifyContent: "space-between",
  },

  registerInput: {
    width: "100%",
    outlineStyle: "none",
    fontFamily: "Kodchasan-Regular",
  },

  //NEXT BUTTON
  nextButtonContainer: {
    width: "80%",
    flex: 1,
    alignItems: "center",
    justifyContent: "flex-end",
    minHeight: 150,
  },
  nextButton: {
    width: "100%",
    paddingVertical: 10,
    borderRadius: 20,
    textAlign: "center",
    marginBottom: 25,
  },
  nextButtonText: {
    fontSize: 13,
    fontFamily: "Kodchasan-Bold",
    textAlign: "center",
  },
  copyrightText: {
    marginBottom: "15%",
    marginTop: "5%",
    fontFamily: "Kodchasan-Regular",
    textAlign: "center",
  },

  //BACK BUTTON
  backButtonContainer: {
    width: "auto",
    position: "absolute",
    top: 70,
    left: 25,
  },
});
